import React from 'react';
import { Row, Col } from 'react-bootstrap';

const DwriManagementInfo = ({ systemInfo, loading, error }) => {
    if (error) return <p className="text-danger">Error loading management data.</p>;
    if (loading && !systemInfo) return <p>Loading...</p>;

    const assignedUserName = systemInfo?.assignedUser
        ? [systemInfo.assignedUser.lastName, systemInfo.assignedUser.firstName].filter(Boolean).join(', ')
        : '';

    return (
        <>
            <Row>
                <Col>
                    <span><b>Assigned To: </b></span>
                    <span>{assignedUserName}</span>
                    <br />
                    <span><b>CAA Date: </b></span>
                    <span>{systemInfo?.ccaDate || 'No CCA'}</span>
                    <br />
                    <span><b>PWS Engineering Report: </b></span>
                    <span>{systemInfo?.engReport ? 'Yes' : 'No'}</span>
                </Col>
                <Col>
                    <span><b>Plan Review File #: </b></span>
                    <span>{systemInfo?.fileNumber || ''}</span>
                </Col>
                <Col>
                    <span><b>Standard Set: </b></span>
                    <span>{systemInfo?.standardSet || ''}</span>
                    <br />
                    <span><b>Peak Day Demand per ERC (gal/day): </b></span>
                    <span>{systemInfo?.peakDayDemand || ''}</span>
                    <br />
                    <span><b>Average Annual Demand per ERC (gal/day): </b></span>
                    <span>{systemInfo?.averageAnnualDemand || ''}</span>
                    <br />
                    <span><b>Equalization Storage (gal): </b></span>
                    <span>{systemInfo?.equalizationStorage || ''}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span><i>Assumptions: 325851 gal/ACFT</i></span>
                </Col>
            </Row>
        </>
    );
};

export default DwriManagementInfo;
